import { Injectable } from '@angular/core';

import { ListResponse } from '../../models/list-response';
import { StaffClockIn, StaffClockInFilters, StaffMemberByPIN, TimeTrackingRole } from '../../models/time-tracking';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class TimeTrackingService {
  /**
   * A service providing access to time tracking roles via the API.
   */
  constructor(
    private apiService: ApiService
  ) {}

  getTimeTrackingRoles(pageNumber?: number,
                       pageSize?: number): Promise<ListResponse<TimeTrackingRole>> {
    return this.apiService.getCollectionNoFilters<TimeTrackingRole>(
      'time-tracking-roles/',
      pageNumber,
      pageSize
    );
  }

  addTimeTrackingRole(role: TimeTrackingRole): Promise<TimeTrackingRole> {
    return this.apiService.postToAPI<TimeTrackingRole>(
      'time-tracking-roles/',
      role
    );
  }

  updateTimeTrackingRole(role: TimeTrackingRole): Promise<TimeTrackingRole> {
    return this.apiService.putToAPI<TimeTrackingRole>(
      role.url,
      role
    );
  }

  clockIn(pin: string, roleId?: number): Promise<void> {
    const postBody: any = {};

    if (roleId) {
      postBody.role_id = roleId;
    }

    return this.apiService.postToAPI<any>(
      'gym-endpoints/time-tracking/clock-in/' + pin + '/',
      postBody
    ).then();
  }

  clockOut(pin: string): Promise<void> {
    return this.apiService.postToAPI<any>(
      'gym-endpoints/time-tracking/clock-out/' + pin + '/',
      {}
    ).then();
  }

  getStaffClockIns(pageNumber?: number,
                   pageSize?: number,
                   filters?: StaffClockInFilters): Promise<ListResponse<StaffClockIn>> {
    return this.apiService.getCollection<StaffClockIn, StaffClockInFilters>(
      'staff-clock-ins/',
      pageNumber,
      pageSize,
      filters
    );
  }

  getStaffClockIn(id: number): Promise<StaffClockIn> {
    return this.apiService.getItem<StaffClockIn>(
      'staff-clock-ins/',
      id
    );
  }

  addStaffClockIn(clockIn: StaffClockIn): Promise<StaffClockIn> {
    return this.apiService.postToAPI<StaffClockIn>(
      'staff-clock-ins/',
      clockIn
    );
  }

  updateStaffClockIn(clockIn: StaffClockIn): Promise<StaffClockIn> {
    return this.apiService.patchToAPI<StaffClockIn>(
      clockIn.url,
      clockIn
    );
  }
}
